module.exports = "/build/web/svg/chevron-small.41848251e51c5df027dd9120c941aed4.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/chevron-small.svg
// module id = 98
// module chunks = 24